export default function SectionEyebrow({ children, className = '' }) {
  return (
    <div className={`section-tag mb-6 marketing-eyebrow ${className}`.trim()}>
      <span className="marketing-eyebrow__dot" aria-hidden="true" />
      {children}
    </div>
  );
}
